'use client';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './SecurityCard.module.css';

interface SecurityCardProps {
	onChangePassword: () => void;
	onExportData: () => void;
	isLoading?: boolean;
}

export const SecurityCard = ({
	onChangePassword,
	onExportData,
	isLoading,
}: SecurityCardProps) => {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
						<h3 className={styles.title}>Segurança e Privacidade</h3>
						<p className={styles.subtitle}>Gerencie a segurança da sua conta</p>
			</div>

			<div className={styles.actions}>
				<button
					className={styles.actionItem}
					onClick={onChangePassword}
					disabled={isLoading}
					type="button"
				>
					<div className={styles.actionContent}>
						<div className={styles.iconWrapper}>
							<LockOutlinedIcon className={styles.icon} />
						</div>
						<div className={styles.actionText}>
							<span className={styles.actionLabel}>Alterar Senha</span>
							<span className={styles.actionDescription}>Atualize sua senha de acesso</span>
						</div>
					</div>
					<ChevronRightIcon className={styles.chevron} />
				</button>

				<button
					className={styles.actionItem}
					onClick={onExportData}
					disabled={isLoading}
					type="button"
				>
					<div className={styles.actionContent}>
						<div className={styles.iconWrapper}>
							<FileDownloadOutlinedIcon className={styles.icon} />
						</div>
						<div className={styles.actionText}>
							<span className={styles.actionLabel}>Exportar Dados</span>
							<span className={styles.actionDescription}>Baixe uma cópia dos seus dados</span>
						</div>
					</div>
					<ChevronRightIcon className={styles.chevron} />
				</button>

			</div>
		</div>
	);
};
